import { Box, Typography } from '@material-ui/core'
import { Modal } from 'components/core/modal/new-modal/Modal'
import { FC } from 'react'
import styled from 'styled-components'
import { UnblockAndSuspendStyledButton } from '../../styled'
import NumOfDaysTextField from './NumOfDaysTextField'
import { TextAreaInput } from './TextAreaInput'

const StyledActionInfoText = styled(Typography)`
  && {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.accent1};
    margin-bottom: -1rem;
    margin-top: 12px;
  }
`

interface IReportModal {
  onClose: () => void
  show: boolean
  title: string
  textareaInputProps: {
    name: string
    placeholder: string
    value: string
    onChange: (event) => void
  }
  buttonProps: {
    disabled?: boolean
    label: string
    onClick: (event) => void
  }
  numberOfSuspendDays?: number
  handleOnchange?: (event) => void
  actionInfoText?: string
}

export const ReportModal: FC<IReportModal> = ({
  show,
  title,
  onClose,
  textareaInputProps,
  buttonProps,
  numberOfSuspendDays,
  handleOnchange,
  actionInfoText
}) => {
  return (
    <>
      <Modal
        show={show}
        title={title}
        onClose={onClose}
        showCancel
        fullWidth
        noBorder
        dialogWidth="sm"
        radius="15px"
        overflow="visible"
        margin="2em 1em 1em 1.4em"
        padding=".5em 2em 1em"
      >
        <Box display={'flex'} flexDirection="column">
          <TextAreaInput
            name={textareaInputProps.name}
            placeholder={textareaInputProps.placeholder}
            label=""
            area
            required
            rowSize={6}
            charLimit={250}
            areaValue={textareaInputProps.value}
            handler={textareaInputProps.onChange}
            descriptionWordCount={textareaInputProps.value?.length}
          />
          {textareaInputProps?.name === 'suspend-user' && (
            <NumOfDaysTextField handleOnchange={handleOnchange} value={numberOfSuspendDays?.toString()} />
          )}
          <StyledActionInfoText>{actionInfoText}</StyledActionInfoText>
          <UnblockAndSuspendStyledButton
            design="primary"
            disabled={buttonProps.disabled}
            onClick={buttonProps.onClick}
          >
            <strong>{buttonProps.label}</strong>
          </UnblockAndSuspendStyledButton>
        </Box>
      </Modal>
    </>
  )
}
